export default __webpack_public_path__ + "static/media/icon-photos.697a3747.svg";